import { Container, Row, Col } from "react-bootstrap";
import NavDropdown from "react-bootstrap/NavDropdown";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import {
  FaBars,
  FaTimes,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaChevronDown,
} from "react-icons/fa";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const location = useLocation();
  const currentPath = location.pathname;

  const toggleMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991 && mobileMenuOpen) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [mobileMenuOpen]);

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About Industry", href: "/about-industry" },
    {
      name: "Our Team",
      dropdown: true,
      items: [
        { name: "AIIFA Governing Bodies Members", href: "/governing-bodies" },
        { name: "AIIFA National Council Members", href: "/national-member" },
        { name: "Life Member", href: "/life-members" },
        { name: "Active Member", href: "/active-member" },
      ],
    },
    { name: "Newsletter", href: "/newsletter", isFlashy: true },

    {
      name: "Event",
      dropdown: true,
      items: [
        { name: "Past Event", href: "/past-events" },
        { name: "Event Video", href: "/past-videos" },
        {
          name: "Upcoming Events",
          dropdown: true,
          items: [
            { name: "Bharat Steel Expo 2026", href: "/bharat-steelexpo-2026" },
            { name: "Bharat Buildcon 2026", href: "/bharat-buildcon-2026" },
          ],
        },
        { name: "Past SteelEx Teaser", href: "/steelex-teasers" },
        { name: "Recent Initiative", href: "recent-initiative" },
        // { name: "CSIR Video", href: "/CSIR-video" },
        {
          name: "CSIR Video",
          dropdown: true,
          items: [
            { name: "Kashi Vishwanath Steels Ltd.", href: "/kashi-vishwanath-steels-ltd" },
            { name: "SBF Ispat Private Limited", href: "/sbf-ispat-private-limited" },
          ],
        },
      ],
    },
    { name: "Steel Handbook", href: "/steel-handbook" },
    { name: "Contact", href: "/contact" },
  ];

  // Helper: checks if any dropdown item matches the URL
  const isDropdownActive = (items) =>
    items.some((item) => item.href === currentPath);

  return (
    <header>
      {/* Topbar */}
      <div id="topbar-wrap" className="topbar-layout1">
        <Container fluid>
          <Row className="g-2 g-lg-0">
            <Col xs={6} className="single-item flex">
              <div className="single-item flex ">
                <FaPhone className="item-icon" />
                <div className="item-content">
                  <div className="item-title">
                    <a href="tel:911127351345">+011-42725051</a>
                  </div>
                </div>
              </div>

              <div className="single-item flex ">
                <FaEnvelope className="item-icon" />
                <div className="item-content">
                  <div className="item-title">
                    <a href="mailto:aaiifa6@gmail.com">aaiifa6@gmail.com</a>,{" "}
                    <a href="mailto:aiifa.steelex@aaiifa.org">
                      aiifa.steelex@aaiifa.org
                    </a>
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={6} className="single-item">
              <div className="header-btn">
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSf8mtYOUJoZu0vTAsc_sFm4ovsWDNfi6OZ8_cSVgnWmxj1ytw/viewform"
                  target="_black"
                  className="btn-primary d-none d-lg-inline-block"
                >
                  Enlist Your Company Here
                </a>
              </div>
              <div className="header-actions">
                <a
                  href="join-us"
                  className="btn-primary d-none d-lg-inline-block"
                >
                  Become A Member
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Navbar */}
      <div className="menu-layout1">
        <Container fluid>
          <Row className="header-height align-items-center justify-content-between">
            <Col xs="8" lg="3">
              <a href="/" className="temp-logo d-inline-block">
                <img src="/media/logo.png" alt="Logo" className="logo-img" />
              </a>
            </Col>

            {/* Desktop Menu */}
            <Col lg="9" className="d-none d-lg-block text-center">
              <nav className="template-main-menu">
                <ul className="nav-list">
                  {navLinks.map((link) =>
                    link.dropdown ? (
                      <li key={link.name} className="nav-item">
                        <NavDropdown
                          title={link.name}
                          id={`dropdown-${link.name}`}
                          className={
                            isDropdownActive(link.items) ? "active" : ""
                          }
                        >
                          {link.items.map((item) =>
                            item.dropdown ? (
                              <div className="nested-dropdown" key={item.name}>
                                <span
                                  style={{
                                    whiteSpace: "nowrap",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                  className="nested-title"
                                >
                                  {item.name} <FaChevronDown />
                                </span>

                                <div className="nested-menu">
                                  {item.items.map((subItem) => (
                                    <a
                                      key={subItem.name}
                                      href={subItem.href}
                                      className="dropdown-item"
                                    >
                                      {subItem.name}
                                    </a>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <NavDropdown.Item
                                key={item.name}
                                href={item.href}
                              >
                                {item.name}
                              </NavDropdown.Item>
                            ),
                          )}
                        </NavDropdown>
                      </li>
                    ) : (
                      <li key={link.name}>
                        <a
                          href={link.href}
                          className={`${currentPath === link.href ? "active" : ""} ${
                            link.isFlashy ? "flashy-newsletter" : ""
                          } nav-link`}
                        >
                          {link.name}

                          {link.isFlashy && (
                            <span className="nav-arrow">▾</span>
                          )}
                        </a>
                      </li>
                    ),
                  )}
                </ul>
              </nav>
            </Col>

            {/* Actions */}
            <Col xs="4" lg="2" className="text-end d-lg-none">
              <div className="header-actions">
                <button
                  onClick={toggleMenu}
                  className="mobile-menu-toggle d-lg-none"
                >
                  {mobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menu-content">
            <ul className="mobile-nav-list">
              {navLinks.map((link) =>
                link.dropdown ? (
                  <li key={link.name} className="mobile-dropdown">
                    <span
                      className={`dropdown-title ${
                        isDropdownActive(link.items) ? "active" : ""
                      }`}
                      onClick={() => toggleDropdown(link.name)}
                    >
                      {link.name}
                      <FaChevronDown
                        className={`dropdown-icon ${
                          openDropdown === link.name ? "rotate" : ""
                        }`}
                      />
                    </span>

                    <ul
                      className={`mobile-submenu ${
                        openDropdown === link.name ? "open" : ""
                      }`}
                    >
                      {link.items.map((item) =>
                        item.dropdown ? (
                          <li key={item.name}>
                            <span
                              className="dropdown-title"
                              onClick={() => toggleDropdown(item.name)}
                            >
                              {item.name}
                              <FaChevronDown
                                className={`dropdown-icon ${
                                  openDropdown === item.name ? "rotate" : ""
                                }`}
                              />
                            </span>

                            <ul
                              className={`mobile-submenu ${
                                openDropdown === item.name ? "open" : ""
                              }`}
                            >
                              {item.items.map((subItem) => (
                                <li key={subItem.name}>
                                  <a
                                    href={subItem.href}
                                    onClick={() => setMobileMenuOpen(false)}
                                  >
                                    {subItem.name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </li>
                        ) : (
                          <li key={item.name}>
                            <a href={item.href}>{item.name}</a>
                          </li>
                        ),
                      )}
                    </ul>
                  </li>
                ) : (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className={currentPath === link.href ? "active" : ""}
                    >
                      {link.name}
                    </a>
                  </li>
                ),
              )}

              <li className="mobile-cta">
                <a href="join-us" className="btn-primary-mobile">
                  Become A Member
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}
